<template>
  <div>
    <div class="vx-row m-2">
      <div class="router-header flex flex-wrap items-center mb-6 mt-5">
        <div
          class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light"
        >
          <h2 class="mb-1" @click="$router.push('/users')">
            {{ $t("users") }}
          </h2>
        </div>
        <div class="vx-breadcrumb ml-4 md:block hidden">
          <ul class="flex flex-wrap items-center">
            <li class="inline-flex">
              <span class="cursor-default">{{ $t("editUser") }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <vs-card class="px-10 py-5">
      <div class="p-10">
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full text-right pr-5">
            <span>{{$t('profilePage.username')}}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="input" v-model="username" disabled/>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full text-right pr-5">
            <span>{{$t('profilePage.firstName')}}*</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="input" v-model="firstName" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full text-right pr-5">
            <span>{{$t('profilePage.lastName')}}*</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="input" v-model="lastName" />
          </div>
        </div>
        <!-- <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full text-right pr-5">
            <span>{{$t('profilePage.nickName')}}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="input" v-model="nickname" />
          </div>
        </div> -->
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full text-right pr-5">
            <span>{{$t('profilePage.email')}}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="input" type="email" v-model="email" />
          </div>
        </div>
        <!-- <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full text-right pr-5">
            <span>{{$t('profilePage.telephone')}}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="input" v-model="telephone" />
          </div>
        </div> -->
        <!-- <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full text-right pr-5">
            <span>{{$t('profilePage.gender')}}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-checkbox color="success" class="m-1" v-model="checkMale"
              >{{$t('profilePage.male')}}</vs-checkbox
            >
            <vs-checkbox color="success" class="m-1" v-model="checkFemale"
              >{{$t('profilePage.female')}}</vs-checkbox
            >
          </div>
        </div> -->
        <!-- <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full text-right pr-5">
            <span>{{$t('profilePage.address')}}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="input" v-model="address" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full text-right pr-5">
            <span>{{$t('profilePage.city')}}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="input" v-model="city" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full text-right pr-5">
            <span>{{$t('profilePage.country')}}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="input" v-model="country" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full text-right pr-5">
            <span>{{$t('profilePage.dateOfBirth')}}</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <v-date-picker
              v-model="dayOfBirth"
              class="cursor-pointer"
              :locale="$i18n.locale"
              :masks="{ title: 'MMMM YYYY' }"
              :max-date="new Date()"
              :popover="{ placement: 'right-center', visibility: 'click' }"
            >
              <template v-slot="{ inputValue, change }">
                <vs-input :value="inputValue" v-on="change" 
                :placeholder="setDateFormat(dayOfBirth)"/>
              </template>
            </v-date-picker>
          </div>
        </div> -->
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full text-right pr-5">
          {{$t('profilePage.password')}}
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <a class="newpass cursor-pointer" @click="changePassword">{{ $t("profilePage.changePassword") }}</a>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-2/3 w-full ml-auto">
            <vs-button class="mr-3 mb-2" @click="updateUserProfile()">บันทึก</vs-button>
          </div>
        </div>
      </div>
    </vs-card>
    <!-- Change Password dialog -->
    <vs-prompt
      :title="$t('profilePage.changePassword')"
      color="primary"
      @accept="acceptAlert"
      @close="close"
      :active.sync="activePassword"
    >
      <div class="con-exemple-prompt">
        <!-- {{ $t("profilePage.changePasswordMessage") }} -->
        <vs-input
          class="input mx-5 my-1"
          type="password"
          :placeholder="$t('profilePage.newPassword')"
          v-model="valMultipe.newPassword"
        />
        <vs-input
          class="input mx-5 ny-1"
          type="password"
          :placeholder="$t('profilePage.confirmPassword')"
          v-model="valMultipe.confirmPassword"
          @keypress.enter="acceptAlert()"
        />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isEmpty } from "lodash";
import moment from "moment";
import _ from "lodash";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapGetters({
      getErrorStatus: "getterError",
    }),
    ...mapState({
      userProfile: (state) => state.profile.userProfile,
    }),
  },
  data() {
    return {
      username: "",
      firstName: "",
      lastName: "",
      nickname: "",
      email: "",
      password: "",
      conPassword: "",
      telephone: "",
      address: "",
      city: "",
      country: "",
      dayOfBirth: "",
      checkMale: false,
      checkFemale: false,
      activePassword: false,
      valMultipe: {
        newPassword: "",
        confirmPassword: "",
      },
    };
  },
  watch: {
    userProfile(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        this.username = this.userProfile.username;
        this.firstName = this.userProfile.firstName;
        this.lastName = this.userProfile.lastName;
        this.nickname = this.userProfile.nickname;
        this.email = this.userProfile.email;
        this.address = this.userProfile.address;
        this.city = this.userProfile.city;
        this.country = this.userProfile.country;
        this.dayOfBirth = this.userProfile.dayOfBirth;
      }
    },
    checkMale(val) {
      if (val == true) {
        this.checkFemale = false;
      }
    },
    checkFemale(val) {
      if (val == true) {
        this.checkMale = false;
      }
    },
  },
  mounted() {
    const username = localStorage.getItem("editUser");
    this.getUserProfile(username);
  },
  methods: {
    getUserProfile(username) {
      this.$store.dispatch("getUserProfile", username);
      this.username = this.userProfile.username;
      this.firstName = this.userProfile.firstName;
      this.lastName = this.userProfile.lastName;
      this.nickname = this.userProfile.nickname;
      this.email = this.userProfile.email;
      this.address = this.userProfile.address;
      this.city = this.userProfile.city;
      this.country = this.userProfile.country;
      this.dayOfBirth = this.userProfile.dayOfBirth;
    },
    async updateUserProfile() {
      if (this.firstName == '', this.lastName == '') {
        this.$fire({
          type: "error",
          title: "ข้อมูลไม่ถูกต้อง",
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
        });
      } else {
        let data = {
          username: this.username,
          password: this.valMultipe.confirmPassword,
        }
        if( (this.valMultipe.newPassword  && this.valMultipe.confirmPassword && !!this.valMultipe.newPassword == !!this.valMultipe.confirmPassword) ) {
          if (this.valMultipe.newPassword  == this.valMultipe.confirmPassword) {
            await this.$store.dispatch("changePassword", data);
          }
        }
        await this.$store.dispatch("updateProfile", {
          username: this.username,
          // password: this.password,
          firstName: this.firstName,
          lastName: this.lastName,
          nickname: this.nickname,
          email: this.email,
          address: this.address,
          telephone: this.telephone,
          gender: this.gender,
          city: this.city,
          country: this.country,
          dayOfBirth: this.dayOfBirth
        });

        const status = await this.getErrorStatus;
        console.log("status ", status);
        if (isEmpty(status)) {
          this.$fire({
            position: "center",
            type: "success",
            html: "<h3 class='m-2'>บันทึกสำเร็จ</h3><br>",
            showConfirmButton: false,
            timer: 1800,
          });
          this.$router.push("/users");
        } else {
          this.$fire({
            position: "center",
            type: "error",
            html: "<h3 class='m-2'>กรุณาตรวจสอบข้อมูลให้ถูกต้อง</h3>",
            showConfirmButton: false,
            timer: 1800,
          });
        }
      }
      
    },
    setDateFormat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Lorem ipsum dolor sit amet, consectetur",
      });
    },
    changePassword() {
      this.activePassword = true;
    },
    acceptAlert() {
      if (this.valMultipe.newPassword  != this.valMultipe.confirmPassword) {
        this.$fire({
          position: "center",
          type: "error",
          html: "<h3 class='m-2'>Passwordไม่ถูกต้อง</h3>",
          showConfirmButton: false,
          timer: 1800,
        });
      }
    },
    close() {
      this.valMultipe.newPassword = ""
      this.valMultipe.confirmPassword = ""
    },
  },
};
</script>

<style>
.input {
  width: 50%;
}
</style>
